import { Controller } from '@hotwired/stimulus'
import { getFlow } from '../helpers/controllerHelpers/utils'
import { debounce } from '../helpers/debounce'

export default class extends Controller {
  static targets = ['data', 'input']
  static values = {
    userData: { type: Object, default: {} },
  }

  declare readonly hasDataTarget: object
  declare readonly dataTarget: HTMLElement
  declare readonly inputTarget: HTMLElement

  connect() {
    const pre = document.createElement('pre')
    pre.setAttribute('data-debug-target', 'data')
    pre.style.border = '1px solid grey'
    pre.style.padding = '10px'
    pre.style.margin = '10px 0px'

    const componentInput = document.createElement('pre')
    componentInput.setAttribute('data-debug-target', 'input')
    componentInput.setAttribute('contentEditable', 'true')
    componentInput.style.border = '1px solid grey'
    componentInput.style.padding = '10px'
    componentInput.style.margin = '10px 0px'
    componentInput.style.minHeight = '100px'

    componentInput.innerText = JSON.stringify(
      {
        id: 'test_component_generated_debug_id',
        key: 'test_component_generated_debug_key',
        text: 'Try me!',
      },
      null,
      2
    )
    const debouncedInput = debounce(this.onPreInput, 250)
    componentInput.addEventListener('input', debouncedInput)

    const testButton = document.createElement('button')
    testButton.innerText = 'Load Component Data'
    testButton.addEventListener('click', (event) => {
      event.preventDefault()
      this.loadComponent()
    })

    const removeButton = document.createElement('button')
    removeButton.innerText = 'Remove Generated Components'
    removeButton.addEventListener('click', (event) => {
      event.preventDefault()
      document.querySelectorAll('.debug-component').forEach((el) => el.remove())
    })

    this.element.appendChild(pre)

    this.element.appendChild(componentInput)
    this.element.appendChild(testButton)
    this.element.appendChild(removeButton)
  }

  userDataValueChanged(userData) {
    if (this.hasDataTarget) this.dataTarget.innerHTML = JSON.stringify(userData, null, 2)
  }

  onPreInput(e) {
    try {
      const data = JSON.parse(e.target.innerText)
      e.target.innerText = JSON.stringify(data, null, 2)
    } catch (error) {
      return
    }
  }

  async loadComponent() {
    let data
    try {
      data = JSON.parse(this.inputTarget.innerText)
    } catch (error) {
      alert('Invalid JSON')
      console.error(error)
      return
    }
    const pageEl = this.element.closest(`[data-page-page-id-value]`)
    const pageId = pageEl?.getAttribute('data-page-page-id-value')

    const page = (getFlow(this).pagesById || {})[String(pageId)] || {}
    try {
      const response = await fetch(`/dev/render/component`, {
        method: 'POST',
        body: JSON.stringify({ components: data, page }),
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      })

      const htmlResponse: { html: string } = await response.json()

      const incomingComponentContainer = document.createElement('div')
      incomingComponentContainer.classList.add('debug-component')
      incomingComponentContainer.innerHTML = htmlResponse.html
        ? htmlResponse.html
        : JSON.stringify(htmlResponse)

      pageEl?.appendChild(incomingComponentContainer)
    } catch (error) {
      console.error(error)
    }
  }
}
